import styled, { css } from 'styled-components';

export const PhoneLabel = styled.div`
  margin-bottom: 0.5rem;
  font-family: Montserrat-Medium, sans-serif;
  font-style: normal;
  font-size: 16px;
  font-weight: bold;
`;
